module.exports = __webpack_public_path__ + "static/media/Modern SHR VR.641e889.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern SHR VR.mp3
// module id = DlKi
// module chunks = 12